module.exports = __webpack_public_path__ + "static/media/logo_management3.4733add6.png";